module.exports = __webpack_public_path__ + "static/media/defaultImg.ac1f5d4f.svg";